import React from 'react';
//import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
//import { blue } from '@material-ui/core/colors';

import { Grid, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

/*
const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});
*/


export default function SimpleDialog(props) {
    const { onYes, onNo, openYesNo} = props;
    const { t } = useTranslation();



    const handleYes = () => {
        onYes();
    };


    const handleNo = () => {
        onNo();
    };


    // onClose={handleClose} 
    return (
        <Dialog maxWidth='xs' fullWidth={true} aria-labelledby="simple-dialog-title" open={openYesNo}>
            <div className='ugly modalBody p-4'>

                <Grid container spacing={2}>
                    <Grid item className='mb-4 text-center' xs={12}><h5>{t('package.modals.yesNo.message')}</h5></Grid>
                    <Grid item className='text-center' xs={3}></Grid>
                    <Grid item className='text-center' xs={3}><Button onClick={handleYes} variant='contained' color='secondary' title={t('package.modals.yesNo.yesTitle')} className="yes-no-modal-yes-button">{t('package.modals.yesNo.yes')}</Button></Grid>
                    <Grid item className='text-center' xs={3}><Button onClick={handleNo} variant='contained' color='secondary' title={t('package.modals.yesNo.noTitle')} className="yes-no-modal-no-button">{t('package.modals.yesNo.no')}</Button></Grid>
                </Grid>
            </div>

        </Dialog>
    );
}
